import { useTranslation } from 'react-i18next';
import { useClientApi } from '@hero/api-hooks';
import { BuildingIcon } from '@hero/web-icons';
import type { Id } from '@hero/schema';
import { ClientRolesBadge } from '../../../Client/Status/ClientRolesBadge';
import { EntityLink } from './EntityLink';
import { normalizeEntityId } from './normalizeEntityId';

export interface ClientCardWidgetProps {
  clientId: Id;
  displaySnapshot?: { name?: string };
}

export const ClientCardWidget = ({ clientId, displaySnapshot }: ClientCardWidgetProps) => {
  const { t } = useTranslation('m-agent');
  const { data: client } = useClientApi(clientId);
  const name =
    client?.name ??
    displaySnapshot?.name ??
    t('widgets.client_card.fallback', 'Client');
  const id = normalizeEntityId(clientId);

  return (
    <EntityLink
      kind='client'
      entityId={id}
      label={name}
      icon={<BuildingIcon className='size-4' />}
      trailing={
        client?.roles?.length ? (
          <ClientRolesBadge roles={client.roles} max={2} />
        ) : undefined
      }
    />
  );
};
